module.exports = __webpack_public_path__ + "static/media/package_dev_backend_plain.6bf9a6c3.svg";